/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TipoRisorsa {
    TUTTO = 0,
    PRODUZIONE = 1,
    QUALITA = 2,
    BILANCE = 3,
    CENTRO_DI_LAVORO = 4,
    STAMPANTE = 5,
    RASPBERRY = 6,
    MAGAZZINO = 7,
    SERVIZIO_ESTERNO = 8,
}
